<template>
  <poptip
    popper-class="active-tasks-modal"
    :word-wrap="true"
    class="active-tasks"
    placement="bottom"
    width="220"
  >

    <taskbar-button
      icon="md-list"
      size="24"
      :show-badge="!!activeTasksCount"
      :click-handler="() => {}"
      tooltip-content="Активные сессии"
    />

    <div class="active-tasks-pop" slot="content">
      <div v-if="!activeTasksCount" class="ms-help ms-nodata">
        Нет активных сессий
      </div>
      <div class="active-tasks-list" v-else>
        <div class="active-tasks-header ms-help">
          Активные сессии
        </div>
        <div class="active-tasks-contract" v-if="contractTaskActive">
          <i-button
            type="success"
            size="default"
            @click="goToActiveTask('contract')"
            long
          >
            Создание нового проекта
          </i-button>
        </div>
      </div>
    </div>
  </poptip>
</template>

<script>
import TaskbarButton from '@/components/parts/taskbar-button'

export default {
  components: {
    TaskbarButton
  },
  computed: {
    contractTaskActive () {
      return this.$store.state.activeTasks.contract.active
    },
    activeTasksCount () {
      const types = ['contract']
      const state = this.$store.state.activeTasks

      return types.reduce((prev, type) => {
        if (state[type].active) prev++

        return prev
      }, 0)
    }
  },
  methods: {
    goToActiveTask (type) {
      switch (type) {
        case 'contract':
          this.$router.push('/app/contracts/edit')
      }
    }
  }
}
</script>

<style lang="less">
.active-tasks {
  margin-right: 8px;

  .ivu-icon {
    cursor: pointer;
    color: rgba(255, 255, 255, 0.7);
    vertical-align: middle;

    &:hover {
      color: rgba(255, 255, 255, 0.4);
    }
  }

  &__badge {
    top: 4px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
      "Microsoft YaHei", "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif;
    height: 14px;
    line-height: 13px;
    min-width: 14px;
    padding: 0;
  }

  &-modal {
    .ivu-poptip-body {
      padding: 8px;
    }
    .ivu-poptip-arrow {
      display: none;
    }
    .ivu-poptip-body-content-word-wrap {
      text-align: left;
      white-space: normal;
    }
  }

  &-header {
    margin-bottom: 8px;
  }
}
</style>
